import React from 'react'
import TestSpeakableText from './TestSpeakableText'
import QuestionSpeakableText from './QuestionSpeakableText'
import PassageSpeakableText from './PassageSpeakableText'
import ResourceSpeakableText from './ResourceSpeakableText'

const SpeakableText = ({ isTestSettings, sourceType = 'test', ...props }) => {
  switch (sourceType) {
    case 'test':
      return <TestSpeakableText {...props} />
    case 'question':
      return <QuestionSpeakableText {...props} />
    case 'passage':
      return <PassageSpeakableText {...props} />
    case 'resource':
      return <ResourceSpeakableText {...props} />
    default:
      return null
  }
}

export default SpeakableText
